import { render, staticRenderFns } from "./vgtLianchuang.vue?vue&type=template&id=e205df9e&scoped=true"
import script from "./vgtLianchuang.vue?vue&type=script&lang=js"
export * from "./vgtLianchuang.vue?vue&type=script&lang=js"
import style0 from "./vgtLianchuang.vue?vue&type=style&index=0&id=e205df9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e205df9e",
  null
  
)

export default component.exports